/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Dynamic dropdown for satellite values
*/

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { CustomFieldDate } from '../../blocklyFieldDate';
import { getAllowedStatements } from '../block_compatibility_checks';
import { dataset, validateToDate, validateFromDate, getBandArray, getCurrentSat} from '../dataset';
import { AreaService } from '@/services/area.service';
import { areaChange } from '../helper_functions';

Blockly.Blocks['input_optical_data'] = {
    init: function () {
        let areas = AreaService.getAreas();
        this.bands = null;

        this.appendDummyInput('area_input')
            .appendField("Satellite: ", 'satel')
            .appendField(new Blockly.FieldDropdown([['Landsat\u00A08', 'l8'], ['Landsat\u00A07', 'l7'],
            ['Landsat\u00A05', 'l5'], ['Landsat\u00A04', 'l4'], ['Sentinel-2', 's2']]), 'dropdown')
            .appendField("      Area: ")
            .appendField(new Blockly.FieldDropdown(areas), "area")
        this.appendDummyInput('area')
            .appendField('Data: ')
            .appendField(new Blockly.FieldDropdown([['Surface Reflectance', '_SR'], ['Top of Atmosphere', ""]]), 'data')
        this.appendDummyInput('dates')
            .appendField("From:     ")
            .appendField(new CustomFieldDate(dataset.setFrom(String(this.getFieldValue('dropdown') + this.getFieldValue('data'))), function (newValue) { return newValue }, 'true'), 'fd')
            .appendField('      To:    ')
            .appendField(new CustomFieldDate(dataset.getTo(String(this.getFieldValue('dropdown') + this.getFieldValue('data'))),function (newValue) { return newValue }, 'true'), 'td');
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('optical'))
        this.setInputsInline(false);
        this.setStyle('imagery');
        this.setTooltip(Blockly.Msg.OPTICAL_DATA_BLOCK_TOOLTIP) ;
        this.setHelpUrl("");
        this.setOnChange(() => {
            if (String(this.getFieldValue('dropdown') + this.getFieldValue('data')) !== this.previous_dataset) {
                this.updateShape_();
                // populate the this.bands property
                let currentSat = getCurrentSat(this);
                this.bands = getBandArray[currentSat]();
                this.previous_dataset = String(this.getFieldValue('dropdown') + this.getFieldValue('data'));
            }

            if (this.getFieldValue('area') !== this.previous_area) {
                if (this.getFieldValue('area') == 'upload_shp') {
                    this.updateAreaParams_('add');
                } else if (this.previous_area == 'upload_shp') {
                    this.updateAreaParams_('remove');
                }
                this.previous_area = this.getFieldValue('area');
            }
        });
        
        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "area_input", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },
    // When a new satellite is selected, update date fields
    updateShape_: function () {
        let fd = dataset.getFrom(String(this.getFieldValue('dropdown') + this.getFieldValue('data')))
        if (fd == null) { fd = '2018-01-01' }
        let td = dataset.getTo(String(this.getFieldValue('dropdown') + this.getFieldValue('data')))
        if (td == null) { td = '2019-01-01' }

        var from = this.getField('fd');
        var to = this.getField('td');

        let fromValue = validateToDate(validateFromDate(this.getFieldValue('fd'), fd), td);
        let toValue = validateFromDate(validateToDate(this.getFieldValue('td'), td), fd);

        from.setValue(fromValue);
        to.setValue(toValue);

        this.getField('fd').setValue(fromValue);
        this.getField('td').setValue(toValue);
    },

    updateAreaParams_: function (param) {
        if (param == 'add') {
            this.getInput('area_input').appendField(" Path: ", "path_text")
                .appendField(new Blockly.FieldTextInput("user/shp_name"), "path");
        } else {
            let input = this.getInput('area_input');
            input.removeField("path_text", true);
            input.removeField("path", true);
        }
    }
};